import { metrics } from '../metrics';

const getRouteNameDefaultHandler = req => {
  return req && req.route && req.route.path ? req.route.path : 'unknown';
};

const getExtraTagsDefaultHandler = () => [];

export const expressRequestMetrics = ({
  getRouteNameHandler = getRouteNameDefaultHandler,
  getExtraTags = getExtraTagsDefaultHandler,
} = {}) => (req, res, next) => {
  const oldEnd = res.end;
  const startTime = Date.now();

  res.end = (...args) => {
    const duration = Date.now() - startTime;
    const { method } = req;
    const { statusCode } = res;
    const endpointName = getRouteNameHandler(req, res);
    const extraTags = getExtraTags(req, res);

    metrics.httpRequestTiming({
      method,
      status: statusCode,
      duration,
      endpointName,
      extraTags,
    });

    oldEnd.apply(res, args);
  };
  next();
};



// WEBPACK FOOTER //
// ./src/middleware/express.js